import React from 'react';
import './CardLastFourInput.scss';

const CardLastFourInput = ({
  name,
  value = '',
  onChange,
  label,
    intl,
  required = true,
  ...props
}) => {
  const [error, setError] = React.useState('');

  const validate = (inputValue) => {
    if (!inputValue) {
      return required ? intl.formatMessage({ id: 'bankDetails.cardFourDigits.err1' }) : '';
    }

    if (inputValue.length !== 4) {
      return intl.formatMessage({ id: 'bankDetails.cardFourDigits.err2' });
    }

    return '';
  };

  const handleChange = (event) => {
    const newValue = event.target.value
      .replace(/\D/g, '')
      .slice(0, 4);

    // Clear error once the value becomes valid
    if (newValue.length === 4) {
      setError('');
    } else if (error) {
      setError(validate(newValue));
    }

    onChange({
      name,
      value: newValue,
      error: validate(newValue),
    });
  };

  const handleBlur = () => {
    setError(validate(value));
  };

  return (
    <div className="card-last-four-input">
      <label htmlFor={name}>{label}</label>
      <input
        {...props}
        name={name}
        value={value}
        maxLength={4}
        inputMode="numeric"
        onChange={handleChange}
        onBlur={handleBlur}
        aria-invalid={!!error}
      />
      {error && (
      <div
        style={{
          color: 'red',
          marginTop: '4px',
        }}
      >
        {error}
      </div>
      )}
    </div>
  );
};

export default CardLastFourInput;
